import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import type { ImportProgress } from '../../../common/interfaces/import-progress';
import type { OrderImportData } from '../constants/orders-import-schema';
import { OrdersService } from '../services/orders.service';

export const importOrdersResolver: ResolveFn<
  (data: OrderImportData[]) => Observable<ImportProgress>
> = () => {
  const ordersService = inject(OrdersService);
  return (data) => ordersService.importOrders(data);
};
